import ExpandSmall from '@athena/forge-icons/dist/ExpandSmall';

import { MultiselectOption } from './Multiselect';
import { MouseEventHandler, ReactElement, TouchEventHandler } from 'react';
import { components, DropdownIndicatorProps, GroupBase } from 'react-select';

const CustomDropdownIndicator = <
  Option extends MultiselectOption,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>(
  props: DropdownIndicatorProps<Option, IsMulti, Group>
): ReactElement => {
  const {
    isDisabled,
    innerProps: { onMouseDown, onTouchEnd, 'aria-hidden': ariaHidden },
  } = props;
  return (
    <components.DropdownIndicator {...props}>
      <ExpandSmall
        size="12px"
        disabled={isDisabled}
        onMouseDown={onMouseDown as MouseEventHandler<SVGElement> | undefined}
        onTouchEnd={onTouchEnd as TouchEventHandler<SVGElement> | undefined}
        aria-hidden={ariaHidden}
      />
    </components.DropdownIndicator>
  );
};

export default CustomDropdownIndicator;
